module.exports = __webpack_public_path__ + "static/img/0.60d27d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20231122/0.jpg
// module id = BB4+
// module chunks = 7